// Material Symbols Rounded glyph (font loaded in index.html).
export function Sym({ name, size = 18, className, style }: { name: string; size?: number; className?: string; style?: React.CSSProperties }) {
  return (
    <span
      className={className}
      style={{ fontFamily: '"Material Symbols Rounded"', fontSize: size, lineHeight: 1, userSelect: 'none', ...style }}
    >
      {name}
    </span>
  )
}
